import { toSearchableString /*, sortNumber, sortString*/ } from 'app/utils';
import * as _ from 'lodash';

const TEMPLATE_NAME = 'ROUTING';

const initialState = () => ({
  loading: false,
  loadedData: [],
  filters: {
    term: '',
    data: []
  }
});

/*
const sort = function (a, b) {
  let result = sortNumber(a.status, b.status);
  if (result !== 0) {
    return result;
  }
  const aName = a.name || null;
  const bName = b.name || null;
  result = sortString(aName, bName);
  if (result !== 0) {
    return result;
  }
  return sortString(a.key, b.key);
};
*/

const filterByTerm = (item, term) => toSearchableString(item).includes(toSearchableString(term));

const filterData = (data, term) => {
  const result = data.filter(item => {
    const professionalName = item.professional.name
      ? filterByTerm(item.professional.name, term)
      : false;
    return professionalName;
  });
  // if (sort) {
  //   result.sort(sort);
  // }

  return result;
};

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        loadedData: newData,
        filters: {
          ...state.filters,
          data: newData
        }
      };
    }
    case `${TEMPLATE_NAME}_PERPAGE_FULFILLED`: {
      const currentData = state.loadedData;
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        loadedData: [...currentData, ...newData],
        filters: {
          ...state.filters,
          data: !_.isEmpty(newData) ? [...currentData, ...newData] : currentData
        }
      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    case `${TEMPLATE_NAME}_SEARCH`: {
      const term = action.payload;

      return {
        ...state,
        filters: {
          ...state.filters,
          term,
          data: filterData(state.loadedData, term)
        }
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }

    case `${TEMPLATE_NAME}_SEARCH_FULFILLED`: {
      const { data, searchTerm } = action.payload;
      return {
        ...state,
        loading: false,
        filters: {
          ...state.filters,
          data: searchTerm ? data : state.loadedData
        }
      };
    }

    default:
      return state;
  }
};

export default reducer;
